export class GeneralInquiry {
    public subject: string;
    public question: string;
    public contactPhoneNumber: string;
    public contactEmail: string;
}
